export function compressImage(file, callback, options = {}) {
  if (!file) return;

  const {
    maxSizeBytes = 1000000,
    initialQuality = 0.9,
    minQuality = 0.4,
    qualityStep = 0.1,
  } = options;

  const reader = new FileReader();

  reader.onload = function (event) {
    const img = new Image();
    img.src = event.target.result;

    img.onload = function () {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      const tryCompress = (quality) => {
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              callback(file);
              return;
            }

            if (blob.size <= maxSizeBytes || quality <= minQuality) {
              const compressedFile = new File([blob], file.name, {
                type: file.type,
              });
              callback(compressedFile);
              return;
            }

            tryCompress(
              Math.max(minQuality, Number((quality - qualityStep).toFixed(2)))
            );
          },
          file.type,
          quality
        );
      };

      tryCompress(initialQuality);
    };
  };

  reader.readAsDataURL(file);
}
